import { useMemo } from 'react';
import { CostRateSourceType } from 'api/cost-rates';
import { useProjectUserTeamsCostRatesQuery } from 'queries/project';

export const useProjectUserTeamsCostRate = (projectId: number) => {
  const { data: userTeamCostRates, isLoading } =
    useProjectUserTeamsCostRatesQuery(projectId, { enabled: false });

  const userLevelCostRateMap: { [key: string]: number } = useMemo(
    () =>
      (userTeamCostRates ?? [])
        .filter((cost) => cost.sourceType === CostRateSourceType.User)
        .reduce((map, currEntry) => {
          return {
            ...map,
            [`${currEntry.sourceId}_${CostRateSourceType.User}`]:
              currEntry.hourlyCostRate,
          };
        }, {}),
    [userTeamCostRates],
  );

  const roleLevelCostRateMap: { [key: string]: number } = useMemo(
    () =>
      (userTeamCostRates ?? [])
        .filter((cost) => cost.sourceType === CostRateSourceType.Role)
        .reduce((map, currEntry) => {
          return {
            ...map,
            [`${currEntry.sourceId}_${CostRateSourceType.Role}`]:
              currEntry.hourlyCostRate,
          };
        }, {}),
    [userTeamCostRates],
  );

  return {
    isCostRatesLoading: isLoading,
    userLevelCostRateMap,
    roleLevelCostRateMap,
  };
};
